export const SUB_FORM_INIT = 'SUB_FORM_INIT';
export const SUB_CHANGE_PRODUCT = 'SUB_CHANGE_PRODUCT';
export const SUB_CHANGE_PACKAGE = 'SUB_CHANGE_PACKAGE';
export const SUB_CHANGE_DATE_TO = 'SUB_CHANGE_DATE_TO';
export const SUB_CHANGE_DATE_FROM = 'SUB_CHANGE_DATE_FROM';
export const SUB_DATE_ERROR = 'SUB_DATE_ERROR';
export const SUB_CHANGE_TYPE_PAYMENT = 'SUB_CHANGE_TYPE_PAYMENT';
export const SUB_CHANGE_PLANE_PRICE = 'SUB_CHANGE_PLANE_PRICE';
export const SUB_CHANGE_FIELDS_AREA = 'SUB_CHANGE_FIELDS_AREA';
export const SUB_CHANGE_SUBSCRIPTION_PERIOD = 'SUB_CHANGE_SUBSCRIPTION_PERIOD';
export const SUB_CHANGE_SHOULD_CREATE_PAYMENT = 'SUB_CHANGE_SHOULD_CREATE_PAYMENT';
export const SUB_CHANGE_FORM_READY = 'SUB_CHANGE_FORM_READY';

export const SUB_CHANGE_AVAILABLE_PRODUCT = 'SUB_CHANGE_AVAILABLE_PRODUCT';
export const SUB_CHANGE_AVAILABLE_PACKAGE = 'SUB_CHANGE_AVAILABLE_PACKAGE';
export const SUB_IS_LOADING_FORM = 'SUB_IS_LOADING_FORM';
export const SUB_FORM_ERROR = 'SUB_FORM_ERROR';

export const SUB_FORM_IS_SENDING = 'SUB_FORM_IS_SENDING';
export const SUB_FORM_NOT_SEND = 'SUB_FORM_NOT_SEND';
export const SUB_FORM_FINISHED_FORM = 'SUB_FORM_FINISHED_FORM';
export const SUB_FORM_IS_SUCCESS = 'SUB_FORM_IS_SUCCESS';

export const EXIST_SUB_IS_LOADING = 'EXIST_SUB_IS_LOADING';
export const EXIST_SUB_MESSAGE = 'EXIST_SUB_MESSAGE';
export const EXIST_SUB_SUBSCRIPTIONS = 'EXIST_SUB_SUBSCRIPTIONS';
export const EXIST_SUB_NOT_LOADING = 'EXIST_SUB_NOT_LOADING';
export const EDIT_EXIST_SUB_ID = 'EDIT_EXIST_SUB_ID';
export const EDIT_EXIST_SUB_CHANGE_DATETIME_FINISH = 'EDIT_EXIST_SUB_CHANGE_DATETIME_FINISH';
export const EDIT_EXIST_SUB_WIDTH = 'EDIT_EXIST_SUB_WIDTH';

export const TOASTER_ADD_MESSAGE = 'TOASTER_ADD_MESSAGE';
export const TOASTER_DELETE_MESSAGE = 'TOASTER_DELETE_MESSAGE';
export const TOASTER_TOKEN_IS_UPDATING = 'TOASTER_TOKEN_IS_UPDATING';
